const FETCH_NDSH8_REPORT_REQUEST = "FETCH_NDSH8_REPORT_REQUEST";
const FETCH_NDSH8_REPORT_SUCCESS = "FETCH_NDSH8_REPORT_SUCCESS";
const FETCH_NDSH8_REPORT_FAILURE = "FETCH_NDSH8_REPORT_FAILURE";

export default {
  FETCH_NDSH8_REPORT_REQUEST,
  FETCH_NDSH8_REPORT_SUCCESS,
  FETCH_NDSH8_REPORT_FAILURE,
};
